import AssetManager from './AssetManager';

const AssetTab = () => (
    <div className="admin-page">
        <h1>Assets</h1>
        <AssetManager />
    </div>
);

export default AssetTab;
